import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import { MOBILE_BREAKPOINT } from '../../../../config/constants';

export const useStyles = makeStyles<Theme>(theme => ({
    title: {
        fontWeight: 600,
        lineHeight: '2rem',
        marginBottom: '1rem',
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            fontSize: '1.5rem',
        },
        [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
            fontSize: '1.75rem',
        },
    },
    subtitle: {
        fontWeight: 400,
        fontSize: '0.9rem',
        lineHeight: '1.4rem',
        marginBottom: '1rem',
    },
    coverImageContainer: {
        cursor: 'pointer',
        position: 'relative',
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            marginBottom: '0.5rem',
        },
        [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
            marginBottom: '1rem',
        },
    },
    coverImage: {
        height: 'auto',
        maxWidth: '100%',
        width: '100%',
        border: '1px solid #dee2e6',
    },
    selectThumbContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        width: '100%',
        flex: 1,
    },
    selectThumbButton: {
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        textTransform: 'none',
        padding: '0.25rem 1rem',
        borderRadius: '25px',
        maxWidth: '225px',
        fontWeight: 400,
        '&:hover': {
            transition: 'all .2s ease-in-out',
            transform: 'scale(1.05)',
            backgroundColor: theme.palette.primary.main,
        },
        marginTop: '2rem',
    },
    pickThumbButton: {
        position: 'absolute',
        right: '2rem',
        bottom: '2rem',
        backgroundColor: theme.palette.primary.main,
        width: '43px',
        height: '45px',
        borderRadius: '30px',
        paddingLeft: 0,
        paddingRight: 0,
        minWidth: '43px',
        '&:hover': {
            transition: 'all .2s ease-in-out',
            transform: 'scale(1.05)',
            backgroundColor: theme.palette.primary.main,
        },
    },
    pickThumbIcon: {
        borderRadius: '10px',
    },
    modal: {
        backgroundColor: 'white',
        borderRadius: '0.5rem',
        paddingTop: '1rem',
        paddingBottom: '1rem',
        position: 'absolute',
        maxWidth: '1250px',
        width: '100%',
        left: 0,
        right: 0,
        marginLeft: 'auto',
        marginRight: 'auto',
        outline: 'none',
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            marginTop: '1rem',
        },
        [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
            marginTop: '3rem',
        },
    },
    modalHeader: {
        borderBottom: '1px solid #dee2e6',
        paddingLeft: '1rem',
        paddingRight: '1rem',
    },
    modalFooter: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: '2rem',
        paddingLeft: '1rem',
        paddingRight: '1rem',
    },
    modalTitle: {
        padding: 0,
        marginBottom: '1rem',
        fontSize: '1rem',
        fontWeight: 400,
    },
    modalContent: {
        paddingLeft: '1rem',
        paddingRight: '1rem',
        paddingTop: '1rem',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignContent: 'center',
        alignItems: 'center',
        justifyItems: 'center',
        justifyContent: 'center',
    },
    imageContainer: {
        width: '75%',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignContent: 'center',
        alignItems: 'center',
        justifyItems: 'center',
        justifyContent: 'center',
    },
    cropperContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        backgroundColor: 'black',
        '& img': {
            maxWidth: '100%',
            maxHeight: '700px',
            height: 'auto',
        },
    },
    cropperButton: {
        textTransform: 'none',
        color: 'white',
        borderRadius: '50px',
        fontSize: '0.9rem',
        padding: '0.25rem 1rem',
        margin: '0 0.125rem',
        fontWeight: 400,
        marginTop: '1rem',
        '&:hover': {
            transition: 'all .2s ease-in-out',
            transform: 'scale(1.05)',
        },
    },
    selectFileButton: {
        backgroundColor: theme.palette.secondary.light,
        '&:hover': {
            backgroundColor: theme.palette.secondary.light,
        },
    },
    saveButton: {
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        },
    },
}));
